import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import { CleanIcon, PaymentIcon, ListIcon, ViewIcon } from 'assets/icons';
import { AccreditationService } from 'services';
import moment from 'moment';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	san: '',
	search: '',
	date: ''
}

class History extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Usuario',
			'Doc. Identidad',
			'Nº San',
			'Fecha Pago',
			'Monto pagado',
			'Método de pago',
			'Nº Referencia',
			'Estatus Chinchin'
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Historial de Acreditaciones',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false,callback = () => {}) => {
		const res: any = await AccreditationService.admin.getHistory({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			date: this.state.form.date && moment(this.state.form.date).format('YYYY-MM-DD')
		});
		this.setState({
			data: res.accreditations.rows,
			last_page: res.accreditations.count
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	view = (e: any, item: any) => {
		e.preventDefault();
	}
	
	render() {
		return (
			<div id="admin-accreditations">
				<div className="row row-tabs">
					<div className="col-md-6">
						<Link to="/admin/accreditations/payments">
							<div className="item-tab">
								<img src={ PaymentIcon } />
								<p>Acreditación</p>
							</div>
						</Link>
					</div>
					<div className="col-md-6">
						<Link to="/admin/accreditations/history">
							<div className="item-tab active">
								<img src={ ListIcon } />
								<p>Historial de Acreditaciones</p>
							</div>
						</Link>
					</div>
				</div>

				<div className="row row-filter">
					<div className="col-md-12">
						<div className="row">
							<div className="row col-md-10">
								<div className="col-md-4">
									<Input
										value={ this.state.form.search }
										name="search"
										placeholder="Buscar"
										label="Nombre participante"
										className="input-table"
										onSubmit={ () => this.load() }
										onChange={ (e: any) => {
											clearTimeout(this.timer);
											this.timer = setTimeout(() => {
												this.load(true);
											},1000);
											this.change(e); 
										} } />
								</div>
								<div className="col-md-4">
									<DatePicker
										label="Fecha de pago"
										placeholder="Fecha"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'date'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.date }
									/>
								</div>
								<div className="col-md-4">
									<Input
										value={ this.state.form.san }
										name="san"
										placeholder="Buscar"
										label="Nº de SAN"
										className="input-table"
										onSubmit={ () => this.load() }
										onChange={ (e: any) => {
											clearTimeout(this.timer);
											this.timer = setTimeout(() => {
												this.load(true);
											},1000);
											this.change(e); 
										} } />
								</div>
							</div>
							<div className="col-md-2">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					</div>
				</div>

				<Table title="Acreditaciones Registradas" data={ this.state.data.length } header={ this.state.header }>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ i?.user?.name + ' ' + i?.user?.lastname }</td>
								<td>{ ((i.user?.document_type?.name || '') + ((i.user?.document_type_id == Constants.DOCUMENT_TYPES.PASSPORT || i.user?.document_type_id == Constants.DOCUMENT_TYPES.COLOMBIA) ? ' - ' : '')) + i.user?.document }</td>
								<td>{ i?.san?.code }</td>
								<td>{ moment(i?.created_at).format('DD/MM/YYYY') }</td>
								<td>{ Globals.formatMiles(i?.amount,true,i.currency_symbol) }</td>
								<td>{ i?.payment_method?.name }</td>
								<td>{ i?.reference }</td>
								<td>{ i?.chinchin_result || '-' }</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(History);